import { useContext } from "react"
import notificationContext from "../contexts/notificationContext"

const useNotificationContext = () =>  useContext(notificationContext)

export default useNotificationContext